import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Formik } from "formik";
import {
  Grid,
  Button,
  Link,
  Card,
  CardContent,
  CardActions,
  CardHeader,
} from "@material-ui/core";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { compose, path } from "ramda";

import UserInfo from "./user";
import CompanyInfo from "./company";
import { withTranslate } from "../../shared/components/translate";
import { validationSchema } from "./validation";
import { createCompany } from "reducers/ducks/company";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(),
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

function ScrollableTabsButtonAuto({ history, translate }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Card className={classes.root}>
      <CardHeader title={translate("company.create.title")} />
      <CardContent>
        <Formik
          validationSchema={validationSchema}
          onSubmit={(val, { setErrors, setSubmitting }) => {
            setSubmitting(true);
            dispatch(createCompany(val))
              .then(() => history.push("/auth/login"))
              .catch((err) => {
                const errors = path(["response", "data", "errors"], err);
                if (errors) setErrors(errors);
              })
              .finally(() => setSubmitting(false));
          }}
          render={(props) => (
            <form onSubmit={props.handleSubmit}>
              <Typography color="textSecondary" variant="h6">
                {translate("company.create.userTitle")}
              </Typography>
              <UserInfo />
              <Typography
                style={{ paddingTop: 8 }}
                color="textSecondary"
                variant="h6"
              >
                {translate("company.create.companyTitle")}
              </Typography>
              <CompanyInfo />
              <CardActions>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Link component={RouterLink} to="/home">
                      <Button fullWidth>
                        {translate("company.create.cancel")}
                      </Button>
                    </Link>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={!props.isValid}
                    >
                      {translate("company.create.accept")}
                    </Button>
                  </Grid>
                </Grid>
              </CardActions>
            </form>
          )}
        />
      </CardContent>
    </Card>
  );
}

export default compose(withTranslate, withRouter)(ScrollableTabsButtonAuto);
